import { render } from "./RegisterStep2.vue?vue&type=template&id=35b723ea&scoped=true"
import script from "./RegisterStep2.vue?vue&type=script&lang=js"
export * from "./RegisterStep2.vue?vue&type=script&lang=js"

import "./RegisterStep2.vue?vue&type=style&index=0&id=35b723ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b723ea"]])

export default __exports__